/* eslint-disable */
import React, { useState, useEffect }  from 'react'
import { DatePicker } from 'antd'
import PropTypes from 'prop-types'
import { isEqual, omit } from 'lodash'
import dayjs from 'dayjs'
import { handleControl } from './control'

const { RangePicker } = DatePicker

const RangePickerF = (props) => {
  const {
    id,
    modalProps, picker,// 组件 功能参数
    value, dateStrValue, dateOfType,// 组件 数据源
    onChange, actionChange // 请求方法
  } = props

  const defaultValue = [
    value[0] ? dayjs(value[0]) : undefined,
    value[1] ? dayjs(value[1]) : undefined,
  ]
  const handleChange = (e, eStr) => {

    let formatValue = {}
    switch (true) {
      case (!e): {
        formatValue = [
          undefined,
          undefined
        ]
        break
      }
      // dateStrValue === true, 提交参数 为 字符串 根据 picker 类型
      case (dateStrValue): {
        formatValue = [
          eStr[0],
          eStr[1]]
        break
      }
      // dateOfType === true, 提交参数为，去除时分秒，根据picker参数
      case (dateOfType): {
        formatValue = [
          +dayjs(e[0]).startOf(picker || 'day'),
          +dayjs(e[1]).endOf(picker || 'day')
        ]
        break
      }
      // 默认 转换 时间戳
      default: {
        formatValue = [
          +dayjs(e[0]),
          +dayjs(e[1])
        ]
        break
      }
    }

    onChange(formatValue, eStr)
  }
  return (
    <RangePicker
      id={id}
    // picker = 'week'
      // picker = 'month'
      // picker = 'quarter'
      // picker = 'year'
      // {...modalProps}
      // defaultValue={useValue}
      // value={useValue}

      // -- modalProps
      allowClear={true}
      style={{ width: 240 }}
      {...modalProps}
      // ---
      defaultValue={defaultValue}
      onChange={handleChange}
    />
  )
}
export default RangePickerF

RangePickerF.defaultProps = {
  propsClassName: 'mode',
  propsClassSpan: '',
  modalProps: {},
  picker: undefined,
  query: {},
  value: [],
  dateStrValue: false,
  dateOfType: true,
  ending: false,
  killPending: false
}